import styled from 'styled-components'

export const MainContainer = styled.div`
  position: relative;
`

export const TableContainer = styled.div`
  position: relative;
  overflow-x: scroll;
  padding-bottom: ${props => props.theme.spacing.sp32};
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`

export const TableHeader = styled.thead`
  text-align: left;
  white-space: nowrap;
`

export const HeaderCell = styled.th`
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
`

export const TableBody = styled.tbody`
  tr:nth-child(odd) {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`
